export default {"src":"/_next/static/media/icon_play_practice.0851a12d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};